export default __webpack_public_path__ + "static/media/3_dingus.b06c2939.svg";